module.exports = __webpack_public_path__ + "img/template-scratch-img.b9052545.svg";